/** Separadores preservados entre tokens (espaço, hífen, barra, parênteses). */
const DISPLAY_TEXT_TOKEN_SPLIT = /(\s+|-|\/|\(|\))/g;

const DISPLAY_TEXT_SEPARATOR_ONLY = /^(\s+|-|\/|\(|\))$/;

/**
 * Formata texto para exibição em tabelas/cards (Title Case por palavra).
 * Unicode-safe: não usa `\b` nem `\w`. Usa `toLocaleLowerCase`/`toLocaleUpperCase` (pt-BR).
 * Não alterar valores salvos — usar apenas na renderização.
 */
export function formatDisplayText(value: string | null | undefined): string {
  if (value == null || value === "") return "";

  return value
    .toString()
    .toLocaleLowerCase("pt-BR")
    .split(DISPLAY_TEXT_TOKEN_SPLIT)
    .map((part) => {
      if (!part.trim()) return part;
      if (DISPLAY_TEXT_SEPARATOR_ONLY.test(part)) return part;

      return part.charAt(0).toLocaleUpperCase("pt-BR") + part.slice(1);
    })
    .join("");
}
